import React, { useContext, useEffect } from "react";
import { toast } from "react-toastify";
import moment from "moment-timezone";

import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import {
  requestBrowserNotificationPermission,
  showBrowserNotification
} from "../../utils/browserNotification";

const ALERT_STORAGE_PREFIX = "schedule-reminder-alert";

const buildReminderKey = (userId, reminder) =>
  `${ALERT_STORAGE_PREFIX}:${userId}:${reminder.id}:${reminder.remindAt}`;

const notifyBrowser = async (title, body) => {
  await requestBrowserNotificationPermission();
  await showBrowserNotification(title, { body });
};

const ScheduleReminderWatcher = () => {
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!user?.id || !user?.companyId) {
      return undefined;
    }

    let mounted = true;

    const checkReminders = async () => {
      try {
        const { data } = await api.get("/schedules/reminders/upcoming");
        const reminders = Array.isArray(data?.reminders) ? data.reminders : [];

        reminders.forEach((reminder) => {
          const storageKey = buildReminderKey(user.id, reminder);
          if (localStorage.getItem(storageKey)) {
            return;
          }

          const contactName = reminder?.contact?.name || "Sin contacto";
          const queueName = reminder?.queue?.name ? ` | ${reminder.queue.name}` : "";
          const whenLabel = moment(reminder.sendAt).format("DD/MM/YYYY hh:mm a");
          const title = "Recordatorio de cita";
          const message = `${contactName}${queueName} a las ${whenLabel}`;

          toast.info(message, {
            autoClose: 12000
          });
          notifyBrowser(title, message);
          localStorage.setItem(storageKey, new Date().toISOString());
        });
      } catch (_error) {
        // Silencioso para no interrumpir la UI si falla una consulta puntual.
      }
    };

    checkReminders();
    const interval = setInterval(() => {
      if (mounted) {
        checkReminders();
      }
    }, 60000);

    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, [user?.id, user?.companyId]);

  return null;
};

export default ScheduleReminderWatcher;
